import React from 'react';
import { Modal } from '../../../../components/Modal';
import './ExtensionEnterprise.scss';
import Button from '../../../../components/Button';

interface ISuccessModalPropTypes {
  isOpen: boolean;
  onClose: () => void;
  newExpirationDate: string;
}

export const SuccessModal = ({
  isOpen,
  onClose,
  newExpirationDate,
}: ISuccessModalPropTypes): React.JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="confirmation-modal-container">
        <div className="confirmation-title">Congratulations!</div>
        <div className="confirmation-description">
          <p>
            Your subscription is extended through {newExpirationDate}. Enjoy another year of Every
            Mother!
          </p>
        </div>
        <Button
          label="Return to My Account"
          styleKey="dark"
          className="Return to My Account"
          onClick={onClose}
        />
      </div>
    </Modal>
  );
};
